import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getMe } from '../../../api/users';

import { REQUEST } from '../../../constants/request';
import {
  checkAndSetLoading,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { saveUserDataToCache } from '../../../utils/userCache';

export const fetchMeUser = createAsyncThunk(
  'currentUser/fetchMeUser',
  async (formData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getMe({
        cancelToken: source.token,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.status);
    }
  },
);

export const fetchMeUserExtraReducers = builder => {
  builder
    .addCase(fetchMeUser.pending, (state, action) => {
      checkAndSetLoading(state.userMeRequest, action);
    })
    .addCase(fetchMeUser.fulfilled, (state, action) => {
      onMatchedRequest(state.userMeRequest, action, () => {
        state.user = action.payload;
        state.currentLoadings.fetchMeUser = REQUEST.idle;
        state.currentRequestIds.fetchMeUser = undefined;

        saveUserDataToCache(
          {
            user: state.user,
          },
          'user',
        );
      });
    })
    .addCase(fetchMeUser.rejected, (state, action) => {
      handleRequestRejection(state.userMeRequest, action);
    });
};
